import { SubscriptionApplyingItem } from '@/models/order/subscription/applying-item/subscription-applying-item'
import { SubscriptionApplyingItemFindBySkuRepository } from '@/models/order/subscription/applying-item/subscription-applying-item-repository'
import { SubscriptionApplyingItemService } from '@/services/api/subscription/subscription-applying-item'

export class DefaultSubscriptionApplyingItemRepository implements SubscriptionApplyingItemFindBySkuRepository {
  constructor(private readonly apiClient: SubscriptionApplyingItemService) {}

  async findBySku(skuId: string): Promise<SubscriptionApplyingItem> {
    const s = await this.apiClient.findBySkuId(skuId)

    return {
      config: {
        range: {
          toString: () => s.config.enable_range.label,
          isFinite: () => s.config.finite,
        },
      },
      cancel: {
        cancellableRange: {
          begin: s.cancel.enable_range.begin,
          end: s.cancel.enable_range.end,
        },
      },
    }
  }
}
